var render = function render(_c,_vm){return _c('mm-alert',{key:"needAuth",staticClass:"order-detail-tips",attrs:{"type":"warning","show-icon":"","closable":false}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('order.orderInfoNone'),expression:"'order.orderInfoNone'"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }